import { firestore } from './../../firebase/utils';

export const handleAddConversation = (id, conversation) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('users')
		.doc(id)
		.collection('conversations')
		.doc()
		.set(conversation)
		.then(() => {
		  resolve();
		})
		.catch(err => {
		  reject(err);
		})
	});
}

export const handleFetchConversations = (id) => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				.collection('users')
					.doc(id)
					.collection('conversations')
					.orderBy('createdDate', 'desc')
  
	  ref
		.get()
		.then(snapshot => {
		
  
		  const data2 = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
				documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			data2
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleFetchConversationsByService = (id, productName) => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				.collection('users')
					.doc(id)
					.collection('conversations')
    
    ref = ref.where('serviceName', '==', productName).orderBy('createdDate', 'desc')
  
	  ref
		.get()
		.then(snapshot => {
		
  
		  const data2 = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
				documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			data2
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleDeleteConversation = (id, documentID) => {
  
	return new Promise((resolve, reject) => {
	  firestore
		.collection('users')
		.doc(id)
		.collection('conversations')
		.doc(documentID)
		.delete()
		.then(() => {
		//   console.log(documentID, 2)
		  resolve();
		})
		.catch(err => {
		  reject(err);
		})
	});
}

export const handleFetchConversation = (conversationID) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('conversations')
		.doc(conversationID)
		.get()
		.then(snapshot => {
  
		  if (snapshot.exists) {
			resolve({
			  ...snapshot.data(),
			  documentID: conversationID
			});
		  }
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleFetchCustomerConversations = (id) => {
	return new Promise((resolve, reject) => {
  
	  
	let ref2 = firestore.collectionGroup('conversations').orderBy('createdDate', 'desc')
	  				
	  
		ref2.get()
		.then(snapshot => {
		
  
		  const data2 = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
				documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			data2
		  });
		})
		.catch(err => {
		  reject(err);
		})

		
	})


}